import React from 'react';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../../fx/FxLog';
import * as FxFetch from '../../../fx/FxFetch';
import { useTranslation } from '../../../hx/useTranslation';
import CxDialog from '../../../cx/CxDialog';
import CxInput from '../../../cx/CxInput';
import CxRadio from '../../../cx/CxRadio';
import CxSearcher from '../../../cx/CxSearcher';
import CxNumber from '../../../cx/CxNumber';
import CxSnackbar from '../../../cx/CxSnackbar';
import CxDlgAlert from '../../../cx/CxDlgAlert'; 
import '../../../../styles/main.css';


const MxPsOTF = (props) => {
  const [{ trans }] = useTranslation();
  const [dlg, setDlg] = React.useState(false);
  const [disabled, ] = React.useState(false);

  const rf_txPs = React.useRef(null);
  const rf_nuNature = React.useRef(null);
  const rf_nuTaxPerc = React.useRef(null);
  const rf_txTypePsGroup = React.useRef(null);
  const rf_txTypePsSubgroup = React.useRef(null);
  const rf_nuFrequency = React.useRef(null);
  const rf_nuAmount = React.useRef(null);
  const rf_txReference = React.useRef(null);

  const r_snack_required = React.useRef(null);
  const r_snack_exists = React.useRef(null);
  
  const r_dlg_alert = React.useRef(null);

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  React.useImperativeHandle(props.xref, () => {
    return {
      setDlg,
    };
  });

  const formLoad = async () => {
  }

  const formSave = async () => {
    // Validaciones de requeridos
    if (rf_txPs.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txPs.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_nuTaxPerc.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_nuTaxPerc.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txTypePsGroup.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txTypePsGroup.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txTypePsSubgroup.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txTypePsSubgroup.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_nuAmount.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_nuAmount.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }

    // --- PROCESO DE GUARDADO ---
    
    // 1. Ocultar ventana principal y mostrar alerta de espera
    setDlg(false); 
    
    r_dlg_alert.current.setText(trans('msg.saving'));
    r_dlg_alert.current.setProgressMsg(trans('msg.please_wait'));
    r_dlg_alert.current.setTextColor('var(--ibs_color_blue)');
    r_dlg_alert.current.setHasButtonClose(false);
    r_dlg_alert.current.setOpen(true);

    let txPs = rf_txPs.current.getVal();
    let nuNature = rf_nuNature.current.getVal();
    let nuTaxPerc = rf_nuTaxPerc.current.getVal();
    let itPsGroup = rf_txTypePsGroup.current.getKey();
    let itPsSubgroup = rf_txTypePsSubgroup.current.getKey();
    let nuFrequency = rf_nuFrequency.current.getVal();
    let txReference = rf_txReference.current.getVal();
    let nuQuantity = 1;
    let nuDiscountPerc = 0;

    let nuAmount = rf_nuAmount.current.getVal();
    let nuPrice = (-1 * ((10000 * nuAmount) / (((nuDiscountPerc - 100) * nuTaxPerc + 100 * nuDiscountPerc - 10000) * nuQuantity)));

    let record = {};
    record['txPs'] = txPs;
    record['txReference'] = txReference;
    record['nuNature'] = nuNature;
    record['nuTaxPerc'] = nuTaxPerc;
    record['itPsGroup'] = itPsGroup;
    record['itPsSubgroup'] = itPsSubgroup;
    record['nuFrequency'] = nuFrequency;
    record['nuPrice'] = nuPrice;
    record['boDrug'] = (
      rf_txTypePsSubgroup.current.getVal().includes('Drug') ||
      rf_txTypePsSubgroup.current.getVal().includes('Medication') ||
      rf_txTypePsSubgroup.current.getVal().includes('Medicine') ||
      rf_txTypePsSubgroup.current.getVal().includes('Medicación') ||
      rf_txTypePsSubgroup.current.getVal().includes('Medicamento')
    ) ? '1' : '0';

    Promise.all([FxFetch.doJsonX("pss/otf", record)]).then((result) => {
      r_dlg_alert.current.setOpen(false); // Cerramos alerta

      if (result[0]) {
        if (result[0].theValue === null) {
          // El PS ya existe: Reabrimos la ventana para que el usuario corrija
          setDlg(true); 
          r_snack_exists.current.setVal(trans('msg.x_exists','field.ps'));
          r_snack_exists.current.setOpen(true);
        } else {
          // Éxito: Se queda cerrada la ventana principal 
          let inPs = result[0].theValue;
          if (props.onOk) props.onOk(inPs, txPs);
        }
      }
    }).catch((error) => {
      // Error técnico: Reabrimos ventana y notificamos
      r_dlg_alert.current.setOpen(false);
      setDlg(true); 
      FxLog.errorx("MxPsOTF.formSave", error);
    });
  }

  const groupCleared = () => {
    rf_txTypePsSubgroup.current.clear();
    rf_txTypePsSubgroup.current.setFilter(`undefined='${undefined}'`);
  }
  const groupSelected = (row) => {
    rf_txTypePsSubgroup.current.clear();
  }
  const subgroupOpen = () => {
    let itPsGroup = rf_txTypePsGroup.current.getKey();
    rf_txTypePsSubgroup.current.setFilter(`t_ps_subgroup.itPsGroup='${itPsGroup}'`);
    return true; 
  }

  return (
    <div>
      <CxDialog title={trans('field.create_x','field.ps')} open={dlg} onOk={formSave} onClose={() => setDlg(false)} >
          <CxInput xref={rf_txPs} label={trans('field.ps')} dbfield="n_ps.txPs" autoselect="true" required disabled={disabled} width='var(--ibs_control_width_md)' />
          <CxRadio xref={rf_nuNature} dbfield="n_ps.nuNature" list={[{ id: '0', type: trans('field.product') }, { id: '1', type: trans('field.service') }]} required autoSelectFirst disabled={disabled} width='var(--ibs_control_width_md)' />
          <CxNumber xref={rf_nuTaxPerc} label={`${trans('field.tax_perc')}`} dbfield="nuTaxPerc" decimals={2} decimalsfixed="true" autoselect="true" width='var(--ibs_control_width_md)' disabled={disabled} required />
          <CxNumber xref={rf_nuAmount} dbfield='dummy_amount' label={`${trans('field.price')}+${trans('field.tax')}`} decimals={2} decimalsfixed="true" autoselect="true" required disabled={disabled} width='var(--ibs_control_width_md)' />
          <CxSearcher xref={rf_txTypePsGroup} label={trans('field.group')} dbfield='t_ps_group.txTypePsGroup' dbfieldkey='n_ps.itPsGroup' onClear={groupCleared} onSelection={groupSelected} url="sett/ps_group" tooltip={trans('field.group')} col_id="itPsGroup" col_tx="txTypePsGroup" 
            columns={[{ id: "0", Header: "ID", accessor: "itPsGroup", show: false }, { id: "1", Header: trans('field.ps'), accessor: row => rf_txTypePsGroup.current.getTable().highlightText(row["txTypePsGroup"]), width: '100%' }]} disabled={disabled} required width='var(--ibs_control_width_md)' />
          <CxSearcher xref={rf_txTypePsSubgroup} label={trans('field.subgroup')} dbfield='t_ps_subgroup.txTypePsSubgroup' dbfieldkey='n_ps.itPsSubgroup' canOpenDialog={subgroupOpen} url="sett/ps_subgroup" tooltip={trans('field.subgroup')} col_id="itPsSubgroup" col_tx="txTypePsSubgroup" 
            columns={[{ id: "0", Header: "ID", accessor: "itPsSubgroup", show: false }, { id: "1", Header: trans('field.ps'), accessor: row => rf_txTypePsSubgroup.current.getTable().highlightText(row["txTypePsSubgroup"]), width: '100%' }]} disabled={disabled} required width='var(--ibs_control_width_md)' />
          <CxInput xref={rf_nuFrequency} dbfield="n_ps.nuFrequency" label={trans('field.frequency')} autoselect="true" inputregex={"^\\d*$"} disabled={disabled} width='var(--ibs_control_width_md)' />
          <CxInput xref={rf_txReference} label={trans('field.reference')} dbfield="n_ps.txReference" autoselect="true" disabled={disabled} width='var(--ibs_control_width_md)' />
      </CxDialog>

      <CxDlgAlert xref={r_dlg_alert} />

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_exists} severity="error" />
    </div>
  );
}

export default MxPsOTF;